import { render, staticRenderFns } from "./allColisFutur.vue?vue&type=template&id=35d0e0c6&"
import script from "./allColisFutur.vue?vue&type=script&lang=js&"
export * from "./allColisFutur.vue?vue&type=script&lang=js&"
import style0 from "./allColisFutur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports